import { IMissingPDFRequest } from '../interfaces';

export const INITIAL_MISSING_PDFS_REQUEST: IMissingPDFRequest = {
  items_per_page: 10,
  page: 1,
  query: '',
  sort_direction: 'desc',
  sort_key: 'prd_date_modified',
};
